module.exports = __webpack_public_path__ + "img/timeBJ.b30d7b89.png";